import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import axios from 'axios';

// import Button from '../../Button/Button';
import Loader from '../../Loader/Loader';

import { useStore } from '../../../hook-store/store';

import { SOCKET_GROUP_URL } from '../../../App';

// import { marks } from '../../../images/marks';
import classes from './GroupUpload.module.css';

const GroupParamBucketFileUpload = props => {
  // console.log('VideoTextTalkUpload.js-props', props);
  const { 
    setShowParamBucketFileUploadModal,
    // noconnectDestUserId,
    // noconnectTextPostHandler,
    joinGroupId,
    groupTextPostHandler,
    isTextPosting,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const userData = store.userData;
  const { groupParamFileData } = store.groupStore;

  const [filePreviews, setFilePreviews] = useState([]);
  const [textInput, setTextInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [imagesData, setImagesData] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const [sizeError, setSizeError] = useState('');

  useEffect(() => {
    if (groupParamFileData) {
      groupParamBucketFileUploadHandler(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
        groupParamFileData,
      )
    }
  },[groupParamFileData]);

  const groupParamBucketFileUploadHandler = async (
    url, 
    token, 
    groupParamFileData,
  ) => {
    try {
      setIsLoading(true);
      setErrorMessage('');

      const formData = new FormData();
      // console.log('joingroupId', joinGroupId, userData)
      // console.log('file', groupParamFileData.file);
      // throw new Error('error-error') 

      formData.append('files', groupParamFileData.file);
      // for (const file of groupParamFileData.files) {
      //   formData.append('files', file);
      // }

      if (userData) {
        formData.append('userId', userData.userId);
      }

      formData.append('joinGroupId', joinGroupId);

      formData.append('isKuraBucketFile', true);

      // formData.append('file', files[0]);
  
      const result = await axios.request({
        method: 'POST',
        url: url + `/file-upload`,
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
        onUploadProgress: (p) => {
          console.log('onUploadProgress', (p.loaded/p.total*100).toFixed(0), p); 
          // this.setState({
          //     uploadProgress: p.loaded / p.total * 100
          // });
        }
      });
  
      console.log(result);

      if (result.data) {
        const fileUrls = result.data.data.fileUrls;
        const fileSizes = result.data.data.fileSizes;

        // const forText = textInput.trim() ? textInput : 'your file';
        const textInput = groupParamFileData.textInput ? groupParamFileData.textInput : 'your file';
        
        // noconnectTextPostHandler(
        //   forText, 
        //   noconnectDestUserId, 
        //   fileUrls,
        //   fileSizes,
        // );

        // console.log('groupParamFileData', groupParamFileData);
        const kuraFileInfo = {
          bucket: groupParamFileData.bucket,
          initialKey: groupParamFileData.initialKey,
          key: groupParamFileData.key,
          mimeType: groupParamFileData.mimeType,
          size: groupParamFileData.size,
        };

        // throw new Error('error-error')
        groupTextPostHandler(
          textInput, 
          joinGroupId,
          fileUrls,
          fileSizes,
          kuraFileInfo,
        );
        // console.log(fileUrls);

        setShowParamBucketFileUploadModal(false);
        dispatch('SET_GROUPPARAMFILEDATA', null);
      }
      
      setIsLoading(false);

      return result;

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      setErrorMessage('File Upload Failed');
      throw err;
    }
  };


  
  let uploadBody;
  
  uploadBody = (
    <div>
      <div className={classes.talkUploadClose}>
        <span className={classes.talkUploadCloseButton}
          onClick={() => {
            setShowParamBucketFileUploadModal(false); 
          }}
        >
          X
        </span>
      </div>
      <div>param-bucket-file-upload</div>
      {/* {groupParamFileData?.file && (
        <audio 
          src={URL.createObjectURL(groupParamFileData.file)}
          controls
        />
      )} */}
      {(isTextPosting || isLoading) && (
        <div>
          <Loader />
        </div>
      )}
      {errorMessage && (
        <div>{errorMessage}</div>
      )}
    </div>
  );

  return (
    <Fragment>
      <div>{uploadBody}</div>
    </Fragment>

  );
}

export default GroupParamBucketFileUpload;